import * as React from 'react';

import * as styles from './NewbuildingPromoCarouselReservedSpace.css';

export const NewbuildingPromoCarouselReservedSpace: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
